import React from "react";
import "./Sidebar.css";
import { Container, Row, Col } from "reactstrap";

const Sidebar = () => {

    return (
        <section>
            <Container className="sidebar-container">
                <div className="sidebar close">
                    <div className="logo-details">
                        <i class="ri-home-5-fill"></i>
                        <span className="logo_name"></span>
                    </div>
                    <ul className="nav-links">
                        <li>
                            <a href="#">
                                <i className="ri-dashboard-line"></i>
                                <span className="link_name">Dashboard</span>
                            </a>
                            <ul className="sub-menu blank">
                                <li><a className="link_name" href="#">Dashboard</a></li>
                            </ul>
                        </li>
                        <li>
                            <div className="iocn-link">
                                <a href="#">
                                    <i className="ri-inbox-unarchive-fill"></i>
                                    <span className="link_name">Category</span>
                                </a>
                                <i className='bx bxs-chevron-down arrow' ></i>
                            </div>
                            <ul className="sub-menu">
                                <li><a className="link_name" href="#">Python + Django</a></li>
                                <li><a href="#">HTML, CSS & JavaScript</a></li>
                                <li><a href="#">PostgreSQL, PHP & MySQL</a></li>
                                <li><a href="#">.NET, DOT.NET, ASP.NET</a></li>
                            </ul>
                        </li>
                        <li>
                            <div className="iocn-link">
                                <a href="#">
                                    <i className="ri-git-repository-fill"></i>
                                    <span className="link_name">Posts</span>
                                </a>
                                <i className='bx bxs-chevron-down arrow' ></i>
                            </div>
                            <ul className="sub-menu">
                                <li><a className="link_name" href="#">Веб қолданбалары</a></li>
                                <li><a href="#">Веб-дизайн элементтері</a></li>
                                <li><a href="#">Кіру пішінінің элементтері</a></li>
                                <li><a href="#">Карта дизайны атрибуты</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="#">
                                <i className="ri-line-chart-fill"></i>
                                <span className="link_name">Analytics</span>
                            </a>
                            <ul className="sub-menu blank">
                                <li><a className="link_name" href="#">Аналитика</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="#">
                                <i className="ri-bar-chart-2-line"></i>
                                <span className="link_name">Chart</span>
                            </a>
                            <ul className="sub-menu blank">
                                <li><a className="link_name" href="#">Диаграмма + Кесте</a></li>
                            </ul>
                        </li>
                        <li>
                            <div className="iocn-link">
                                <a href="#">
                                    <i className="ri-add-circle-fill"></i>
                                    <span className="link_name">Plugins</span>
                                </a>
                                <i className='bx bxs-chevron-down arrow' ></i>
                            </div>
                            <ul className="sub-menu">
                                <li><a className="link_name" href="#">Плагиндер</a></li>
                                <li><a href="#">UI беті</a></li>
                                <li><a href="#">Пигменттер</a></li>
                                <li><a href="#">Қорап белгішелері</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="#">
                                <i className="ri-ie-fill"></i>
                                <span className="link_name">Explore</span>
                            </a>
                            <ul className="sub-menu blank">
                                <li><a className="link_name" href="#">Зерттеу</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="#">
                                <i className="ri-chat-history-fill"></i>
                                <span className="link_name">History</span>
                            </a>
                            <ul className="sub-menu blank">
                                <li><a className="link_name" href="#">Тарих</a></li>
                            </ul>
                        </li>
                        <li>
                            <a href="#">
                                <i className="ri-tools-fill"></i>
                                <span className="link_name">Setting</span>
                            </a>
                            <ul className="sub-menu blank">
                                <li><a className="link_name" href="#">Параметр</a></li>
                            </ul>
                        </li>
                        <li>
                            <div className="profile-details">
                                <div className="profile-content">
                                </div>
                                <div className="name-job">
                                    <div className="profile_name">Аты</div>
                                    <div className="job">Name</div>
                                </div>
                                <i className='bx bx-log-out' ></i>
                            </div>
                        </li>
                    </ul>
                </div>
            </Container>
        </section>
    );
};

export default Sidebar;
